import { Card, Grid, Stack, Typography } from '@mui/material';
import { HeroMetricsCard } from '@features/campaigns/components/Summary/HeroMetricsCard';
import { HeroMetricProps } from '@features/campaigns/components/Summary/HeroMetric';

const LEFT_ALIGN_METRICS_LIMIT = 2;

type CampaignPulseCardProps = {
  incrementalOutcomeMetrics: HeroMetricProps[];
  mediaAttributedMetrics: HeroMetricProps[];
  mediaInputMetrics: HeroMetricProps[];
  children: React.ReactNode;
};

export const CampaignPulseCard = (props: CampaignPulseCardProps) => {
  return (
    <Card sx={{ padding: '1.5rem' }}>
      <Stack spacing={3}>
        <Stack spacing={1}>
          <Typography variant="h5">Here&apos;s your campaign pulse.</Typography>
          {props.children}
        </Stack>

        <Grid container spacing="1rem">
          <Grid size={12}>
            <HeroMetricsCard
              title="INCREMENTAL MEDIA OUTCOMES"
              metrics={props.incrementalOutcomeMetrics}
              justifyContent={
                props.incrementalOutcomeMetrics.length <=
                LEFT_ALIGN_METRICS_LIMIT
                  ? 'flex-start'
                  : undefined
              }
            />
          </Grid>

          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <HeroMetricsCard
              title="MEDIA ATTRIBUTED OUTCOMES"
              metrics={props.mediaAttributedMetrics}
              sx={{ height: '100%' }}
            />
          </Grid>

          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <HeroMetricsCard
              title="MEDIA INPUTS"
              metrics={props.mediaInputMetrics}
              sx={{ height: '100%' }}
            />
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
